import React, { useLayoutEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { setGlobalLoader } from "../../../redux/slices/globalLoader";
import { useDispatch, useSelector } from "react-redux";
import GlobalLoader from "../../admin/shared/globalLoader";



const AdvertiserLayout = () => {
    const dispatch = useDispatch();
    const loaderState = useSelector((state) => state.globalLoader);
    const navigate = useNavigate();
    window.navigate_ = navigate;




    return (
        <>
            {loaderState ? (
                <GlobalLoader />
            ) : (
                <div className="page">
                  
                    <Outlet />
                </div>
            )}
        </>
    );
};
export default AdvertiserLayout;
